import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createQueryParams } from '../../shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { FirmwareFilters } from '../models/firmware-filters.model';

export const getFirmwareTotalCount: AsyncThunk<
  number,
  Partial<FirmwareFilters> | undefined,
  Record<string, unknown>
> = withMandant<Partial<FirmwareFilters> | undefined, number>(
  Endpoints.FIRMWARE_TOTAL_COUNT,
  'firmware/get-total-count',
  async ({ args, endpoint }) => {
    const queryParams = createQueryParams({
      name: args?.name,
      brandId: args?.brandId,
      modelIds: args?.modelIds,
      ecuIds: args?.ecuIds,
      platformIds: args?.platformIds,
    });

    const { data }: AxiosResponse<number> = await axiosInstance.get(
      endpoint + queryParams
    );

    return data;
  }
);
